import { render, staticRenderFns } from "./RegistrationStepTwo.vue?vue&type=template&id=62a32b31&scoped=true"
import script from "./RegistrationStepTwo.vue?vue&type=script&lang=js"
export * from "./RegistrationStepTwo.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStepTwo.vue?vue&type=style&index=0&id=62a32b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a32b31",
  null
  
)

export default component.exports